import { trialDays } from '@listening/frontend/pricing';
import { Link } from '@tanstack/react-router';
import { localizeHref } from '@/paraglide/runtime';

export function BlogCtaButton({ className }: { className?: string }) {
  return (
    <Link className={className} to={localizeHref('/app/continue')}>
      {getString(trialDays)}
    </Link>
  );
}

const getString = (trialDays: number) => {
  if (trialDays === 1) {
    return 'Try the app free for 1 day';
  }
  if (trialDays === 28) {
    return 'Try the app free for 4 weeks';
  }
  if (trialDays === 7) {
    return 'Try the app free for 1 week';
  }
  return `Try the app free for ${trialDays.toString()} days`;
};
